import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=78dc257c&scoped=true&"
import script from "./OrderHeader.vue?vue&type=script&lang=ts&"
export * from "./OrderHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=78dc257c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc257c",
  null
  
)

export default component.exports